import React from 'react'
import styled from 'styled-components'
import { CustomCheckBox } from 'src/components/Global/CheckBox/Checkbox'
import { ModalButton } from 'src/components/Global/Button/Button'
import { Ppicture } from 'src/assets'
import { Link, useLocation } from 'react-router-dom'
const MystoryWrapper = styled.div`
  padding-top: 23px;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 88vh;
  h1 {
    font-family: ${({ theme }) => theme.fontFamily.visuelt};
    font-style: normal;
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.x1};
    line-height: 32px;
    color: ${({ theme }) => theme.colors.CollaboBlue};
  }
  h6 {
    font-size: ${({ theme }) => theme.fontSize.x4};
    line-height: 24px;
    letter-spacing: 0.75px;
    color: ${({ theme }) => theme.colors.gray};
    font-weight: 500;
    margin-top: -10px;
  }
  .check {
    display: flex;
    align-items: center;
    margin-top: -10px;
  }
  h4 {
    font-size: ${({ theme }) => theme.fontSize.s};
    line-height: 20px;
    color: ${({ theme }) => theme.colors.dark};
    padding-top: 10px;
  }
  .picture {
    border-radius: 50%;
    margin-right: 30px;
  }
  .line {
    height: 3px;
    width: auto;
    background: ${({ theme }) => theme.colors.grey};
    margin: 10px -47px;
    margin-top: -15px;
  }
  .pic {
    display: flex;
    align-items: center;
    padding: 10px 0px 40px 0px;
  }
  .area {
    width: 100%;
    height: 150px;
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid #858c94;
    box-sizing: border-box;
    border-radius: 8px;
    margin-top: -20px;
  }
`
const Mystory = () => {
  let location = useLocation()
  return (
    <MystoryWrapper>
      <div>
        <h1>My Story</h1>
        <h6>
          Join thousands of customers to share with the world how F&K Savings
          have helped your financial life since you started using the platform.
        </h6>
        <div className="pic">
          <img src={Ppicture} alt="" className="picture" />
          <h4>Tap on the picture to change it.</h4>
        </div>
        <h6>How has F&K Savings helped you save and improve your finances?</h6>
        <textarea className="area"></textarea>
        <div className="check">
          <CustomCheckBox />
          <h4>
            I confirm my story to be true and give permission for it to be
            shared by F&K Savings
          </h4>
        </div>
      </div>
      <div className="top">
        <div className="line"></div>
        <Link to={`/quicksave-one`} state={{ backgroundLocation: location }}>
          <ModalButton>Tell Story</ModalButton>
        </Link>
      </div>
    </MystoryWrapper>
  )
}
export { Mystory }
